import { z } from 'zod';

import { OptionalEmailString } from '../validations/email';
import { PositiveMonetaryValue } from '../validations/fields';

export const OriginationData = z.object({
  fundedAtClosing: PositiveMonetaryValue.optional(),
  loanOfficerName: z.string().optional(),
  loanOfficerEmail: OptionalEmailString,
  loanProcessorName: z.string().optional(),
  loanProcessorEmail: OptionalEmailString,
});
export type OriginationData = z.infer<typeof OriginationData>;
